import intl from '../utils/intl';

export const setPageTitle = (id, params = {}) => {
  document.title = intl
    .formatMessage({ id: 'common.app_name' })
    .concat(' - ')
    .concat(intl.formatMessage({ id }, params));
};
